// Dependencies
// -----------------------------------------------
import React from 'react';
import { connect } from 'react-redux';

// Components
// -----------------------------------------------
import ContactForm from '../../forms/contact';
import ContactV2 from '../../forms/contact-v2';

// -----------------------------------------------
// COMPONENT->CONTACT ----------------------------
// -----------------------------------------------
class Contact extends React.Component {

  // Render
  // ---------------------------------------------
  render() {
    return this.props.useDesignKit ? (
      <ContactV2 {...this.props} subject="Property Inquiry" />
    ) : (
      <section id="details-contact">
        <main>
          <div>
            <ContactForm {...this.props} subject="Property Inquiry" />
          </div>
        </main>
      </section>
    );
  }
}

// Map State To Props
// -----------------------------------------------
function mapStateToProps(state) {
  return {
    brand: state.brand ? state.brand : {},
    listing: state.listing ? state.listing : {}
  };
}

// Export
// -----------------------------------------------
export default connect(mapStateToProps)(Contact);
